import dayjs from "dayjs";
import { catchError } from "../../catchErrors";
import {
  INCORRECT_PASSWORD,
  LOGIN_BLOCK_ERROR,
  LOGIN_BLOCK_ERROR_SINGULAR,
  LOGIN_BLOCK_RESTORE_PASSWORD_URL,
  LOGIN_BLOCK_WARNING,
  LOGIN_BLOCK_WARNING_SINGULAR,
  LOGIN_ERROR,
  USER_NOT_ACTIVATED,
  USER_NOT_EXIST,
} from "../../resources";
import { deleteCookie, getCookie, setCookie } from "../../storage";
import { addToast, cleanToastsContainer } from "../../components/toasts";
import { LOGIN_BLOCK_MAX_TRIES, LOGIN_BLOCK_MINUTES, LOGIN_BLOCK_MINUTES_COOKIE_NAME, LOGIN_BLOCK_TRIES_COOKIE_NAME, LOGIN_URL } from "./settings";
import { showModal, EuiModalSize } from "../../components/modal";
import { closeAlertSubModal } from "./alerts";

let loginBlockRemovalTimeout: any;
let modalInit: boolean = false;

$(() => {
  

  $(document).on("click", "[psf-create-alert-login], [psf-create-alert-login-mobile]", (e) => {
    if(!modalInit) initLoginModal();
    closeAlertSubModal();
    showModal("#loginModal", { size: EuiModalSize.XL });
    handleLoginBlockErrorToast();
    handleLoginBlockActions();
    setLoginBlockRemoval();
  });
});

function handleLoginBlock(): void {
  handleLoginBlockMaxTriesCookie();
  handleLoginBlockMinutesCookie();
  handleLoginBlockToast();
  handleLoginBlockActions();
}

function handleLoginBlockMaxTriesCookie(): void {
  let currentLoginTries: string = getCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME);
  if(currentLoginTries == '') currentLoginTries = '1';
  else currentLoginTries = (parseInt(currentLoginTries) + 1).toString();
  if(parseInt(currentLoginTries) <= LOGIN_BLOCK_MAX_TRIES)
    setCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME, currentLoginTries, '/');
}

function handleLoginBlockMinutesCookie(): void {
  const currentLoginTries: number = parseInt(getCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME));
  if(currentLoginTries == LOGIN_BLOCK_MAX_TRIES) {
    const dateLimit: Date = _getMoreMinutesFromNow(LOGIN_BLOCK_MINUTES);
    setCookie(
      LOGIN_BLOCK_MINUTES_COOKIE_NAME, 
      dateLimit.toISOString(), 
      '/', 
      dateLimit);
    deleteCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME, '/');
    setCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME, currentLoginTries, '/', dateLimit);
  }
}

function handleLoginBlockToast(): void {
  const currentLoginTries: number = parseInt(getCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME));
  if(currentLoginTries == 1)
    return;
  else if(currentLoginTries == (LOGIN_BLOCK_MAX_TRIES - 1))
    addToast(
      _getLoginBlockWarningSingularMessage(), 
      'warning', 
      1000000, 
      true,
      false);
  else if(currentLoginTries < LOGIN_BLOCK_MAX_TRIES)
    addToast(
      _getLoginBlockWarningMessage(currentLoginTries), 
      'warning', 
      1000000, 
      true,
      false);
  else if(currentLoginTries == LOGIN_BLOCK_MAX_TRIES) {
    handleLoginBlockErrorToast();
    setLoginBlockRemoval();
  }
}

function handleLoginBlockErrorToast(): void {
  const currentLoginTries: number = parseInt(getCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME));
  if(currentLoginTries == LOGIN_BLOCK_MAX_TRIES) {
    clearTimeout(loginBlockRemovalTimeout);
    const dateLoginBlock = dayjs(getCookie(LOGIN_BLOCK_MINUTES_COOKIE_NAME));
    const dateNow = dayjs();
    const dateSecondsDifference: number = dateLoginBlock.diff(dateNow, 'seconds');
    const dateMinutesDifference: number = Math.ceil(dateSecondsDifference / 60);
    let message = '';
    if(dateMinutesDifference <= 1)
      message = _getLoginBlockErrorSingularMessage();
    else
      message = _getLoginBlockErrorMessage(dateMinutesDifference);
    addToast(message, 'error', 1000000, true, false);
  }
}

function handleLoginBlockActions(): void {
  const dateLoginBlock = getCookie(LOGIN_BLOCK_MINUTES_COOKIE_NAME);
  if(dateLoginBlock != '') {
    $("#submitLogin").attr("disabled", "true");
    $("#blocked-access-error").show()
  } else {
    $("#blocked-access-error").hide();
    $("#submitLogin").removeAttr("disabled");
  }
}

function removeLoginBlockCookies(): void {
  deleteCookie(LOGIN_BLOCK_TRIES_COOKIE_NAME, '/');
  deleteCookie(LOGIN_BLOCK_MINUTES_COOKIE_NAME, '/');
}

function setLoginBlockRemoval(): void {
  const dateLoginBlock = getCookie(LOGIN_BLOCK_MINUTES_COOKIE_NAME);
  if(dateLoginBlock != '') {
    const dateLoginBlockDate = dayjs(getCookie(LOGIN_BLOCK_MINUTES_COOKIE_NAME));
    const dateNow = dayjs();
    const dateSecondsDifference: number = dateLoginBlockDate.diff(dateNow, 'seconds');

    loginBlockRemovalTimeout = setTimeout(() => {
      removeLoginBlockCookies();
      handleLoginBlockActions();
      cleanToastsContainer();
    }, dateSecondsDifference * 1000)
  }
}

function _getLoginBlockWarningSingularMessage(): string {
  const message: string = LOGIN_BLOCK_WARNING_SINGULAR;
  return message.replace('-0-', LOGIN_BLOCK_MINUTES.toString());
}

function _getLoginBlockWarningMessage(currentLoginTries: number): string {
  const message: string = LOGIN_BLOCK_WARNING;
  return message.replace('-0-', currentLoginTries.toString()).replace('-1-', LOGIN_BLOCK_MINUTES.toString());
}

function _getLoginBlockErrorSingularMessage(): string {
  const message: string = LOGIN_BLOCK_ERROR_SINGULAR;
  return message.replace('-0-', LOGIN_BLOCK_RESTORE_PASSWORD_URL);
}

function _getLoginBlockErrorMessage(minutes: number): string {
  const message: string = LOGIN_BLOCK_ERROR;
  return message.replace('-0-', minutes.toString()).replace('-1-', LOGIN_BLOCK_RESTORE_PASSWORD_URL);
}

function _getMoreMinutesFromNow(minutes: number): Date {
  return new Date(new Date().getTime() + (minutes * 60000));
}

function _checkSubmitButton(): void {
  const dateLoginBlock = getCookie(LOGIN_BLOCK_MINUTES_COOKIE_NAME);
  if(dateLoginBlock == '')
    $("#submitLogin").removeAttr("disabled");
}

function initLoginModal() {
  const loginForm = $("#loginForm");
  const submitLogin = $("#submitLogin");

  if (loginForm[0] != null) {
    const formSettings = $.data(loginForm[0], "validator").settings;

    formSettings.submitHandler = (loginForm: any) => {
      $("input", loginForm).blur();
      submitLogin.prop("disabled", true);
      const loginData = {
        UrlReturn: $("#loginReturn").val(),
        User: $("#loginUser").val(),
        Password: $("#loginPassword").val(),
      };

      $("#loginReturn").val()?.toString() ?? "/";
      window.dataLayer?.push({
        event: "Login_popup_oferta_call",
      });
      $.post(LOGIN_URL, loginData)
        .done((result) => {
          removeLoginBlockCookies();
          window.dataLayer?.push({
            event: "Login_popup_oferta_call_ok",
          });
          if(window.changeUser) window.changeUser(result.workerGuid.toUpperCase());
          if(window.addBrazeEvent) window.addBrazeEvent("B2C - Log in");
          setTimeout(() => window.location.reload(), 500);
        })
        .fail((error) => {
          let errorMessage: string;
          const validator = $("#loginForm").validate();
          switch (error.status) {
            case 400:
              errorMessage = INCORRECT_PASSWORD;
              handleLoginBlock();
              validator.showErrors({
                Password: errorMessage,
              });
              break;
            case 403:
              errorMessage = USER_NOT_ACTIVATED;
              validator.showErrors({
                User: errorMessage,
              });
              break;
            case 404:
              errorMessage = USER_NOT_EXIST;
              validator.showErrors({
                User: errorMessage,
              });
              break;
            default:
              errorMessage = LOGIN_ERROR;
              validator.showErrors({
                User: errorMessage,
              });
              break;
          }
        })
        .catch(catchError)
        .always(() => {
          _checkSubmitButton();
        });
    };
  }
  modalInit = true;
}